export default __webpack_public_path__ + "static/media/Salus.4414db81.svg";